var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 169,
    viewBox: "0 0 31 169",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4671 167H0M18.4671 160.38H0M18.4671 153.76H0M18.4671 147.139H0M18.4671 140.519H0M18.4671 133.899H0M18.4671 127.279H0M18.4671 120.659H0M18.4671 114.039H0M18.4671 107.418H0M18.4671 100.798H0M18.4671 94.178H0M18.4671 87.5578H0M18.4671 80.9377H0M18.4671 74.3175H0M18.4671 67.6973H0M18.4671 61.0771H0M18.4671 54.4569H0M18.4671 47.8368H0M18.4671 41.2166H0M18.4671 34.5964H0M18.4671 27.9762H0M18.4671 21.356H0M18.4671 14.7358H0M18.4671 8.11567H0M18.4671 1.49548H0",
    stroke: "#FA0073",
    strokeWidth: 1.46,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31 166.99H16.0412",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31 160.37H16.0412",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31 153.74L16.0412 153.75",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31 147.12H16.0412",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31 140.499H16.0412",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31 133.879H16.0412",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31 127.259H16.0412",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31 120.639H16.0412",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31 114.019H16.0412",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M31 107.398H16.0412",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M31 100.778H16.0412",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31 94.1581H16.0412",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M31 87.5379H16.0412",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M31 80.9178H16.0412",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M31 74.2976H16.0412",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M31 67.6773H16.0412",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M31 61.0571H16.0412",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M31 54.437H16.0412",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M31 47.8168H16.0412",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M31 41.1965H16.0412",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M31 34.5765H16.0412",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M31 27.9565H16.0412",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M31 21.3359H16.0412",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M31 14.7059L16.0412 14.7159",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M31 8.0856H16.0412",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M31 1.46558H16.0412",
    stroke: "#FA0073",
    strokeWidth: 2.93,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup4);
export default __webpack_public_path__ + "static/media/group4.77ebc594855d1166252870afdeb86afe.svg";
export { ForwardRef as ReactComponent };